// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3fUJG","tab":"Tabs_tab__j9ssu","tabActive":"Tabs_tabActive__B5hYb"};